import React, { Suspense } from "react";
// import ReactDOM from "react-dom";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import Spinner from "./components/Spinner";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { LoginProvider } from "./context/loginContext";
import { SessionProvider } from "./context/sessionContext";
import { GET_PROD_OR_DEV } from "./constants/api";
import { DEV } from "./constants/defaults";

if (String(GET_PROD_OR_DEV) === String(DEV)) {
  console.log("###############################");
  console.log("######  DEVELOPMENT MODE ######");
  console.log("###############################");
  console.log("--- !!!!!!! CHANGE: !!!!!!! ---");
  console.log("-------- aws-export.js --------");
  console.log("--- !!!!!!! TO PROD !!!!!!! ---");
  console.log("###############################");
  console.log("###############################");
}
// inicializar i18n
console.log("idioma", i18n.language)
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement); // Use createRoot
  root.render(
    <React.StrictMode>
      <SessionProvider>
        <LoginProvider>
          <App />
        </LoginProvider>
      </SessionProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
